/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React from 'react';
import clsx from 'clsx';

export const TableHeader = ({ children, className }: { children: React.ReactNode[]; className: string }) => {
  return (
    <thead>
      <tr className={clsx('uppercase border-b-2 border-primary-500 text-gray-30', className)}>
        {children.map((child, index) => (
          <th className='px-4 text-left font-normal' key={'common-th-' + index}>
            {child}
          </th>
        ))}
      </tr>
    </thead>
  );
};
